import { fromBanglaDigits } from "./money";

/** Bangladeshi mobile operator prefixes (013–019). */
const MOBILE_PATTERN = /^01[3-9]\d{8}$/;

/**
 * Normalizes a Bangladeshi mobile number to E.164 (+8801XXXXXXXXX).
 * Accepts 01XXXXXXXXX, 8801XXXXXXXXX and +8801XXXXXXXXX, with spaces, dashes and Bangla digits.
 * Returns null when the input is not a valid BD mobile number.
 */
export function normalizeBdMobile(input: string): string | null {
  let digits = fromBanglaDigits(input).replace(/[\s\-().]/g, "");
  if (digits.startsWith("+")) digits = digits.slice(1);
  if (digits.startsWith("880")) digits = digits.slice(2);
  if (!MOBILE_PATTERN.test(digits)) return null;
  return `+88${digits}`;
}

/** Local display form: 01XXX-XXXXXX. */
export function formatBdMobile(e164: string): string {
  const local = e164.replace(/^\+88/, "");
  return `${local.slice(0, 5)}-${local.slice(5)}`;
}
